import React, { useState, useEffect, useRef, useCallback } from 'react';
import { api } from './api';
import { CARRIERS_MAP, PAYMENT_MAP } from './sharedConfig';
// Escala compacta del panel (Layout: html.tk-esc80 = zoom 80 %): las coordenadas de pantalla se dividen por este factor
const escZ = () => (document.documentElement.classList.contains('tk-esc80') ? 0.8 : 1);

const SEGMENTO_CONFIG = {
  nuevo:      { label:'Nuevo',      color:'#3b82f6', bg:'rgba(59,130,246,0.08)' },
  recurrente: { label:'Recurrente', color:'#8b5cf6', bg:'rgba(139,92,246,0.08)' },
  vip:        { label:'VIP',        color:'#d97706', bg:'rgba(217,119,6,0.08)' },
  inactivo:   { label:'Sin pedidos',   color:'#9ca3af', bg:'rgba(156,163,175,0.1)' },
};
const AVATAR_COLORS = ['#6ee7b7','#93c5fd','#fca5a5','#fcd34d','#c4b5fd','#86efac','#fdba74','#67e8f9'];
const TABS = [
  { id:'todos', label:'Todos' },
  { id:'vip', label:'VIP' },
  { id:'recurrente', label:'Recurrentes' },
  { id:'nuevo', label:'Nuevos' },
  { id:'inactivo', label:'Sin pedidos' },
];
const fmt = (n) => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(n);
const initials = (name) => (name||'?').split(' ').slice(0,2).map(w=>(w||'')[0]).join('').toUpperCase();
const fmtDate = (d) => {
  if (!d) return '';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '';
  const m = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  return `${date.getDate()} ${m[date.getMonth()]}`;
};
const getOrderStatus = (o) => {
  if (o.carrier_status) {
    const s = (o.carrier_status||'').toLowerCase();
    if (s.includes('entreg')) return {label:'Entregado',color:'#16a34a'};
    if (s.includes('transito')||s.includes('ruta')) return {label:'En tránsito',color:'#d97706'};
    if (s.includes('novedad')||s.includes('devol')) return {label:'Novedad',color:'#ef4444'};
    if (s.includes('bodega')||s.includes('recog')) return {label:'En bodega',color:'#3b82f6'};
    return {label:o.carrier_status,color:'#999'};
  }
  if (o.tracking_number) return {label:'Enviado',color:'#3b82f6'};
  if (o.confirmation_status==='confirmed') return {label:'Confirmado',color:'#16a34a'};
  if (o.confirmation_status==='cancelled') return {label:'Cancelado',color:'#ef4444'};
  return {label:'Pendiente',color:'#d97706'};
};

const SortArrow = ({dir}) => (
  <svg width="8" height="8" viewBox="0 0 8 8" style={{flexShrink:0}}>
    <path d={dir==='asc'?'M4 1L7 5.5H1Z':'M4 7L1 2.5H7Z'} fill="#1a1a1a"/>
  </svg>
);
const BagIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>;

const STYLES = `
.ct{--ease:cubic-bezier(0.32,0.72,0,1);--fast:150ms;--normal:220ms;flex:1;display:flex;flex-direction:column;overflow:hidden;background:#fff;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#111;}
.ct *{box-sizing:border-box;}
@keyframes ct-up{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}
.ct-backdrop{position:fixed;inset:0;z-index:99;}
.ct-header{padding:28px 36px 0;flex-shrink:0;animation:ct-up .35s ease-out both;}
.ct-title-row{display:flex;align-items:flex-end;justify-content:space-between;gap:16px;margin-bottom:20px;}
.ct-title{font-size:26px;font-weight:600;color:#111;letter-spacing:-0.6px;line-height:1.1;margin:0;}
.ct-subtitle{font-size:13px;color:#6B7280;margin:5px 0 0;}
.ct-actions{display:flex;gap:8px;align-items:center;}
.ct-btn{display:inline-flex;align-items:center;gap:7px;height:36px;padding:0 13px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;font-size:13px;font-weight:400;color:#374151;cursor:pointer;font-family:inherit;transition:background var(--fast),transform var(--fast);white-space:nowrap;}
.ct-btn:hover{background:#F7F7F7;transform:translateY(-1px);}
.ct-btn:active{transform:scale(0.97);}
.ct-btn-primary{background:#111;color:#fff;border-color:#111;}
.ct-btn-primary:hover{background:#2a2a2a;}
.ct-btn-import{}
.ct-btn-icon{padding:0 9px;justify-content:center;}
.ct-more-wrap{position:relative;}
.ct-more-drop,.ct-filter-drop{position:absolute;top:calc(100% + 6px);right:0;background:#fff;border:1px solid #EAEAEA;border-radius:8px;padding:4px;min-width:180px;z-index:200;box-shadow:0 12px 32px rgba(0,0,0,0.10);animation:ct-dropIn 160ms var(--ease) both;}
.ct-more-item,.ct-filter-item,.ct-ctx-item{display:flex;align-items:center;gap:9px;padding:8px 10px;border-radius:6px;cursor:pointer;font-size:13px;color:#111;font-weight:400;transition:background var(--fast);}
.ct-more-item:hover,.ct-filter-item:hover,.ct-ctx-item:hover{background:#F5F5F5;}
@keyframes ct-dropIn{from{opacity:0;transform:translateY(-4px);}}

.ct-controls{display:flex;align-items:center;padding:0 36px;flex-shrink:0;gap:10px;flex-wrap:wrap;border-bottom:1px solid #EFEFEF;margin:0 0 14px;}
.ct-tabs{display:flex;gap:2px;flex-shrink:0;}
.ct-tab{font-size:13px;height:38px;padding:0 12px;border:none;background:transparent;color:#6B7280;cursor:pointer;font-family:inherit;font-weight:400;border-bottom:2px solid transparent;margin-bottom:-1px;transition:color var(--fast),border-color .3s var(--ease),background var(--fast);border-radius:6px 6px 0 0;}
.ct-tab:hover{color:#111;background:#FAFAFA;}
.ct-tab.active{color:#111;border-bottom-color:#111;}
.ct-tab-count{margin-left:6px;font-size:11px;color:#9CA3AF;font-variant-numeric:tabular-nums;}
.ct-tab.active .ct-tab-count{color:#111;}
.ct-controls-right{display:flex;align-items:center;gap:8px;margin-left:auto;padding:6px 0;}
.ct-search{display:flex;align-items:center;gap:8px;background:#F4F4F4;border:1px solid transparent;border-radius:6px;padding:0 11px;height:34px;width:260px;transition:border-color var(--fast),background var(--fast);}
.ct-search:focus-within{background:#fff;border-color:#111;}
.ct-search input{background:none;border:none;outline:none;font-size:13px;color:#111;font-family:inherit;width:100%;}
.ct-search input::placeholder{color:#9CA3AF;}
.ct-search-clear{background:none;border:none;cursor:pointer;padding:2px;display:flex;opacity:0.5;}
.ct-btn-filter{height:34px;}
.ct-btn-filter.active{background:#111;color:#fff;border-color:#111;}
.ct-filter-title{font-size:12px;font-weight:400;color:#6B7280;padding:6px 10px;}
.ct-filter-dot{width:7px;height:7px;border-radius:50%;flex-shrink:0;}
.ct-results{font-size:12px;color:#9CA3AF;white-space:nowrap;}

.ct-bulk{display:flex;align-items:center;gap:8px;padding:8px 14px;background:#111;border-radius:8px;margin:0 36px 10px;animation:ct-bulkIn 200ms var(--ease) both;}
@keyframes ct-bulkIn{from{opacity:0;transform:translateY(6px);}}
.ct-bulk-info{font-size:13px;color:#fff;margin-right:auto;}
.ct-bulk-btn{border-radius:6px;border:1px solid rgba(255,255,255,0.18);background:transparent;color:#fff;font-size:12.5px;font-weight:400;cursor:pointer;font-family:inherit;padding:6px 12px;transition:background var(--fast);}
.ct-bulk-btn:hover{background:rgba(255,255,255,0.1);}
.ct-bulk-danger{border-color:rgba(248,113,113,0.45);color:#fecaca;}

.ct-list-area{flex:1;overflow-y:auto;overflow-x:hidden;margin:0 36px 24px;border:1px solid #EFEFEF;border-radius:8px;}
.ct-list-area::-webkit-scrollbar{width:5px;} .ct-list-area::-webkit-scrollbar-thumb{background:#E3E3E3;border-radius:3px;}
.ct-head{display:grid;grid-template-columns:2.4fr 2.4fr 1fr 1fr 110px;align-items:center;padding:0 16px;height:38px;gap:8px;background:#FAFAFA;border-bottom:1px solid #EFEFEF;position:sticky;top:0;z-index:2;}
.ct-head-cell{font-size:11.5px;font-weight:400;color:#6B7280;display:flex;align-items:center;gap:4px;cursor:pointer;user-select:none;white-space:nowrap;}
.ct-head-cell:hover{color:#111;}
.ct-cb-all{margin-right:8px;flex-shrink:0;}

.ct-row{display:grid;grid-template-columns:2.4fr 2.4fr 1fr 1fr 110px;align-items:center;padding:0 16px;min-height:62px;gap:8px;border-bottom:1px solid #F3F3F3;transition:background var(--fast);cursor:pointer;position:relative;animation:ct-up .3s ease-out both;}
.ct-row:last-of-type{border-bottom:none;}
.ct-row:hover{background:#FAFAFA;}
.ct-row.selected{background:#F5F5F5;}
.ct-row.selected::before{content:'';position:absolute;left:0;top:10px;bottom:10px;width:2px;background:#111;border-radius:2px;}
@keyframes ct-rowIn{from{opacity:0;transform:translateY(5px);}}

.ct-cell-contact{display:flex;align-items:center;gap:11px;min-width:0;}
.ct-av-wrap{width:34px;height:34px;position:relative;flex-shrink:0;}
.ct-av{width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11.5px;font-weight:500;color:#1f2937;transition:opacity var(--fast);}
.ct-cb-wrap{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity var(--fast);}
.ct-row:hover .ct-cb-wrap,.ct-row.selected .ct-cb-wrap{opacity:1;}
.ct-row:hover .ct-av,.ct-row.selected .ct-av{opacity:0;}
.ct-cb{appearance:none;-webkit-appearance:none;width:16px;height:16px;border:1.5px solid #CFCFCF;border-radius:4px;cursor:pointer;position:relative;background:#fff;flex-shrink:0;transition:all var(--fast);}
.ct-cb:checked{background:#111;border-color:#111;}
.ct-cb:checked::after{content:'';position:absolute;left:4px;top:1px;width:4px;height:8px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);}
.ct-contact-info{min-width:0;}
.ct-name{font-size:13.5px;font-weight:400;color:#111;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-phone{font-size:12px;color:#6B7280;margin-top:2px;font-variant-numeric:tabular-nums;}

.ct-cell-product{display:flex;align-items:center;gap:10px;min-width:0;}
.ct-prod-thumb{position:relative;border-radius:6px;overflow:hidden;background:#F4F4F4;flex-shrink:0;width:38px;height:38px;}
.ct-prod-ph{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;}
.ct-prod-thumb img{width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .3s ease;position:relative;z-index:1;display:block;}
.ct-prod-thumb img.loaded{opacity:1;}
.ct-prod-badge{position:absolute;bottom:2px;right:2px;min-width:16px;height:16px;border-radius:4px;background:rgba(17,17,17,0.85);color:#fff;font-size:9.5px;font-weight:500;display:flex;align-items:center;justify-content:center;padding:0 3px;z-index:2;}
.ct-prod-info{min-width:0;}
.ct-prod-name{font-size:13px;color:#111;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-prod-meta{font-size:11.5px;color:#9CA3AF;margin-top:2px;white-space:nowrap;}
.ct-no-order{font-size:12.5px;color:#9CA3AF;}

.ct-cell-city{font-size:13px;color:#374151;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-cell-value{min-width:0;}
.ct-val{font-size:13.5px;font-weight:500;color:#111;font-variant-numeric:tabular-nums;}
.ct-val-zero{color:#C4C4C4;font-weight:400;}
.ct-orders-count{font-size:11.5px;color:#9CA3AF;margin-top:2px;}
.ct-seg{font-size:12.5px;font-weight:400;display:inline-flex;align-items:center;gap:6px;white-space:nowrap;background:transparent !important;color:#374151 !important;padding:0;}
.ct-seg::before{content:'';width:6px;height:6px;border-radius:50%;background:var(--seg,#9CA3AF);}

.ct-row-dots{position:absolute;right:10px;top:50%;transform:translateY(-50%);opacity:0;transition:opacity var(--fast);}
.ct-row:hover .ct-row-dots{opacity:1;}
.ct-dots-btn{width:28px;height:28px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background var(--fast);}
.ct-dots-btn:hover{background:#F4F4F4;}

.ct-ctx{position:fixed;background:#fff;border:1px solid #EAEAEA;border-radius:8px;padding:4px;min-width:190px;z-index:300;box-shadow:0 12px 32px rgba(0,0,0,0.10);animation:ct-dropIn 150ms var(--ease) both;}
.ct-ctx-danger{color:#B42318;}
.ct-ctx-danger:hover{background:#FEF6F6;}
.ct-ctx-sep{height:1px;background:#EFEFEF;margin:4px 6px;}

.ct-loading-more{display:flex;align-items:center;justify-content:center;padding:16px;gap:8px;color:#9CA3AF;font-size:12.5px;}
.ct-spinner{width:16px;height:16px;border:2px solid #E6E6E6;border-top-color:#111;border-radius:50%;animation:ct-spin 0.7s linear infinite;}
@keyframes ct-spin{to{transform:rotate(360deg)}}
.ct-footer{display:flex;align-items:center;justify-content:space-between;padding:10px 16px;font-size:12px;color:#6B7280;background:#FAFAFA;border-top:1px solid #EFEFEF;position:sticky;bottom:0;}
.ct-all-loaded{color:#6B7280;}
.ct-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;color:#9CA3AF;gap:12px;font-size:13px;}

@keyframes ct-pulse{0%,100%{opacity:0.4}50%{opacity:0.75}}
.ct-skel{animation:ct-pulse 1.5s ease-in-out infinite;background:#EDEDED;border-radius:4px;}
.ct-skel-circle{width:34px;height:34px;border-radius:50%;}
.ct-skel-square{width:38px;height:38px;border-radius:6px;}
.ct-skel-badge{width:70px;height:12px;}

/* Ficha del contacto: panel lateral ancho (mismo patrón que Pedidos) */
.ct-panel-overlay{position:fixed;inset:0;background:rgba(17,17,17,0);z-index:400;transition:background var(--normal) ease;}
.ct-panel-overlay.open{background:rgba(17,17,17,0.32);}
.ct-panel{position:fixed;top:0;right:0;bottom:0;width:min(860px,94vw);background:#fff;z-index:401;transform:translateX(100%);transition:transform 320ms var(--ease);overflow-y:auto;box-shadow:-16px 0 48px rgba(0,0,0,0.12);}
.ct-panel.open{transform:translateX(0);}
.ct-panel::-webkit-scrollbar{width:5px;} .ct-panel::-webkit-scrollbar-thumb{background:#E3E3E3;border-radius:3px;}
.ctp-head{position:sticky;top:0;background:#fff;z-index:2;display:flex;align-items:center;gap:14px;padding:18px 24px;border-bottom:1px solid #EFEFEF;}
.ctp-av{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:500;color:#1f2937;flex-shrink:0;}
.ctp-name{font-size:19px;font-weight:600;color:#111;letter-spacing:-0.3px;margin:0;}
.ctp-meta{display:flex;align-items:center;gap:8px;font-size:13px;color:#6B7280;margin-top:3px;flex-wrap:wrap;}
.ctp-sep{color:#D1D5DB;}
.ctp-actions{margin-left:auto;display:flex;gap:8px;align-items:center;}
.ctp-x{width:30px;height:30px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#6B7280;font-size:16px;line-height:1;transition:background var(--fast),transform var(--fast);}
.ctp-x:hover{background:#F4F4F4;} .ctp-x:active{transform:scale(.94);}
.ctp-grid{display:grid;grid-template-columns:minmax(0,1.5fr) minmax(0,1fr);gap:16px;padding:20px 24px 28px;align-items:start;}
.ctp-col{display:flex;flex-direction:column;gap:16px;min-width:0;}
.ctp-card{border:1px solid #EFEFEF;border-radius:8px;padding:16px 18px;animation:ct-up .35s ease-out both;}
.ctp-col:last-child .ctp-card{animation-delay:60ms;}
.ctp-h{display:flex;align-items:baseline;justify-content:space-between;font-size:14px;font-weight:600;color:#111;margin-bottom:12px;}
.ctp-h span{font-size:13px;font-weight:400;color:#6B7280;}
.ctp-row{display:flex;justify-content:space-between;gap:12px;font-size:13px;padding:5px 0;}
.ctp-row span{color:#6B7280;}
.ctp-row b{font-weight:400;color:#111;text-align:right;word-break:break-word;}
.ctp-stats{display:grid;grid-template-columns:repeat(3,1fr);background:#F7F7F7;border-radius:8px;margin:0 24px;}
.ctp-stat{padding:12px 16px;position:relative;}
.ctp-stat+.ctp-stat::before{content:'';position:absolute;left:0;top:12px;bottom:12px;width:1px;background:#E6E6E6;}
.ctp-stat small{display:block;font-size:12px;color:#6B7280;}
.ctp-stat b{display:block;font-size:18px;font-weight:500;color:#111;margin-top:3px;font-variant-numeric:tabular-nums;}
.ctp-btns{display:flex;flex-direction:column;gap:8px;}
.ctp-btns .ct-btn{justify-content:center;width:100%;}
.ct-btn-danger{color:#B42318;border-color:#F0DADA;}
.ct-btn-danger:hover{background:#FEF6F6;}
.ct-panel-order{display:flex;gap:12px;padding:12px 0;border-top:1px solid #F3F3F3;animation:ct-up .3s ease-out both;}
.ct-panel-order:first-of-type{border-top:none;padding-top:0;}
.ct-panel-order-info{flex:1;min-width:0;}
.ct-panel-order-title{font-size:13.5px;font-weight:400;color:#111;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-panel-order-price{font-size:14px;font-weight:500;color:#111;font-variant-numeric:tabular-nums;white-space:nowrap;}
.ct-panel-order-meta{font-size:12px;color:#6B7280;margin-top:3px;display:flex;align-items:center;gap:5px;flex-wrap:wrap;}
.ct-panel-order-meta img{width:14px;height:14px;border-radius:3px;object-fit:contain;}
.ct-panel-order-status{display:inline-flex;align-items:center;gap:5px;margin-top:5px;font-size:12px;color:#374151;}
.ct-status-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}
.ct-panel-notes{font-size:13px;color:#9CA3AF;margin:0;}

/* Modales (patrón Nueva conversación) */
.ct-overlay{position:fixed;inset:0;background:rgba(17,17,17,0.32);z-index:500;display:flex;align-items:center;justify-content:center;animation:ct-overlayIn .2s ease-out both;}
@keyframes ct-overlayIn{from{opacity:0;}}
.ct-modal{background:#fff;border-radius:10px;max-width:calc(100vw - 32px);max-height:88vh;overflow-y:auto;padding:22px;box-shadow:0 24px 64px rgba(0,0,0,0.16),0 0 0 1px rgba(0,0,0,0.04);animation:ct-modalIn .3s var(--ease) both;}
@keyframes ct-modalIn{from{opacity:0;transform:translateY(12px) scale(0.98);}}
.ct-modal-hdr{display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;}
.ct-modal-title{font-size:17px;font-weight:600;color:#111;}
.ct-modal-close{width:30px;height:30px;border-radius:6px;border:1px solid #E6E6E6;background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;color:#6B7280;line-height:1;transition:background var(--fast);}
.ct-modal-close:hover{background:#F4F4F4;}
.ct-modal-section{font-size:12px;font-weight:400;color:#6B7280;margin:16px 0 8px;}
.ct-modal-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
.ct-modal-field label{font-size:12px;color:#6B7280;display:block;margin-bottom:5px;font-weight:400;}
.ct-modal-field input,.ct-modal-field select,.ct-modal-field textarea{width:100%;padding:8px 11px;border-radius:6px;border:1px solid #E3E3E3;font-size:13px;font-family:inherit;outline:none;color:#111;background:#fff;transition:border-color var(--fast);}
.ct-modal-field input,.ct-modal-field select{height:36px;padding:0 11px;}
.ct-modal-field input:focus,.ct-modal-field select:focus,.ct-modal-field textarea:focus{border-color:#111;}
.ct-modal-err{margin-top:12px;font-size:12.5px;color:#B42318;background:#FEF5F5;border:1px solid #F5DADA;border-radius:6px;padding:8px 10px;}
.ct-modal-submit{width:100%;height:38px;border-radius:6px;border:none;background:#111;color:#fff;font-size:13px;font-weight:400;cursor:pointer;font-family:inherit;margin-top:16px;transition:background var(--fast),transform var(--fast);}
.ct-modal-submit:hover{background:#2a2a2a;} .ct-modal-submit:active{transform:scale(.98);} .ct-modal-submit:disabled{opacity:.5;cursor:not-allowed;}
.ct-import-info{background:#FAFAFA;border:1px solid #EFEFEF;border-radius:6px;padding:10px 12px;margin-bottom:14px;font-size:12.5px;color:#374151;line-height:1.5;}
.ct-import-formats{display:flex;gap:6px;margin-bottom:14px;flex-wrap:wrap;}
.ct-import-tag{font-size:11.5px;padding:3px 8px;border-radius:4px;border:1px solid #E6E6E6;color:#374151;font-weight:400;}
.ct-drop-zone{border:1.5px dashed #D6D6D6;border-radius:8px;padding:28px;text-align:center;cursor:pointer;transition:border-color var(--fast),background var(--fast);}
.ct-drop-zone:hover,.ct-drop-zone.dragging{border-color:#111;background:#FAFAFA;}
.ct-import-result{background:#F6FBF7;border:1px solid #D7EEDD;border-radius:8px;padding:16px;margin-bottom:14px;text-align:center;}
.ct-import-result-num{font-size:28px;font-weight:500;color:#15803d;}
.ct-import-result-label{font-size:13px;color:#15803d;}
.ct-import-preview{display:flex;align-items:center;gap:10px;padding:7px 0;border-bottom:1px solid #F3F3F3;}
.ct-import-preview-av{width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9.5px;font-weight:500;color:#1f2937;}
.ct-import-help{margin-top:14px;padding:10px 12px;background:#FAFAFA;border-radius:6px;font-size:12px;color:#6B7280;line-height:1.6;}

@media(max-width:1100px){
  .ct-head,.ct-row{grid-template-columns:2fr 2fr 0.8fr 0.9fr 100px;}
  .ct-search{width:210px;}
}
@media(max-width:900px){
  .ct-head,.ct-row{grid-template-columns:2.4fr 2fr 1fr 100px;}
  .ct-head-city,.ct-cell-city{display:none;}
  .ctp-grid{grid-template-columns:1fr;}
  .ct-search{width:170px;}
}
@media(max-width:600px){
  .ct-header{padding:20px 16px 0;}
  .ct-controls{padding:0 16px;}
  .ct-list-area{margin:0 16px 16px;}
  .ct-head{display:none;}
  .ct-row{display:flex;flex-wrap:wrap;padding:12px 14px;gap:0;min-height:auto;}
  .ct-cell-contact{width:100%;margin-bottom:8px;}
  .ct-cell-product{width:65%;}
  .ct-cell-value{width:35%;text-align:right;display:flex;flex-direction:column;align-items:flex-end;}
  .ct-cell-city{display:none;}
  .ct-row-dots{right:14px;top:auto;bottom:12px;transform:none;opacity:1;}
  .ct-search{width:100%;}
  .ct-controls-right{width:100%;flex-wrap:wrap;}
  .ct-results{display:none;}
  .ct-bulk{margin:0 16px 10px;flex-wrap:wrap;}
  .ctp-stats{grid-template-columns:1fr 1fr 1fr;margin:0 16px;}
  .ctp-grid{padding:16px;}
  .ctp-head{padding:14px 16px;flex-wrap:wrap;}
  .ct-modal{padding:18px;}
}
@media(prefers-reduced-motion:reduce){
  .ct,.ct *{animation-duration:0.01ms !important;animation-iteration-count:1 !important;transition-duration:0.01ms !important;}
}
`;

export default function Contacts({ user, onNav, onLogout }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [nextPage, setNextPage] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [tab, setTab] = useState('todos');
  const [search, setSearch] = useState('');
  const [sortCol, setSortCol] = useState('nombre');
  const [sortDir, setSortDir] = useState('asc');
  const [showSegmento, setShowSegmento] = useState(false);
  const [selected, setSelected] = useState([]);
  const [menuId, setMenuId] = useState(null);
  const [menuPos, setMenuPos] = useState({top:0,left:0});
  const [moreMenu, setMoreMenu] = useState(false);
  const [detailContact, setDetailContact] = useState(null);
  const [panelOpen, setPanelOpen] = useState(false);
  const [panelOrders, setPanelOrders] = useState([]);
  const [panelOrdersLoading, setPanelOrdersLoading] = useState(false);
  const [panelInfo, setPanelInfo] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [importing, setImporting] = useState(false);
  const [newContact, setNewContact] = useState({nombre:'',telefono:'',email:'',notas:''});
  const [creating, setCreating] = useState(false);
  const [createErr, setCreateErr] = useState('');
  const listRef = useRef(null);
  const fileInputRef = useRef(null);
  const initialLoad = useRef(true);

  const [segCounts, setSegCounts] = useState(null);
  const listParams = (extra={}) => {
    const p = { limit:50, ...extra };
    if (search.trim()) p.search = search.trim();
    if (tab !== 'todos') p.segmento = tab;
    return p;
  };
  const loadCounts = () => fetch('https://talku.online/contacts/count',{headers:{'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`}})
    .then(r=>r.json()).then(d=>{ if (typeof d.count==='number') setTotalCount(d.count); setSegCounts(d.segmentos||null); }).catch(()=>{});
  // Lista desde el backend con búsqueda y segmento (sobre TODOS los contactos)
  const reloadSeq = useRef(0);
  const reload = () => {
    const seq = ++reloadSeq.current;
    setLoading(true); setSelected([]);
    api.getContacts(listParams()).then(data => {
      if (seq !== reloadSeq.current) return;
      setContacts(data.contacts || []);
      setNextPage(data.next_page || null); setHasMore(!!data.next_page);
      setLoading(false);
      setTimeout(() => { initialLoad.current = false; }, 400);
    }).catch(() => { if (seq === reloadSeq.current) setLoading(false); });
  };
  useEffect(() => { loadCounts(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = setTimeout(reload, search ? 350 : 0);
    return () => clearTimeout(t);
  }, [search, tab]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadMore = useCallback(() => {
    if (loadingMore || !hasMore || !nextPage) return;
    setLoadingMore(true);
    api.getContacts(listParams({page_info:nextPage})).then(data => {
      if (data.contacts?.length > 0) {
        setContacts(prev => {
          const ids = new Set(prev.map(c=>c.id));
          return [...prev, ...data.contacts.filter(c=>!ids.has(c.id))];
        });
      }
      if (data.next_page) setNextPage(data.next_page);
      else { setNextPage(null); setHasMore(false); }
      setLoadingMore(false);
    }).catch(() => setLoadingMore(false));
  }, [loadingMore, hasMore, nextPage, search, tab]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleScroll = useCallback((e) => {
    const {scrollTop, scrollHeight, clientHeight} = e.target;
    if (scrollHeight - scrollTop - clientHeight < 200) loadMore();
  }, [loadMore]);

  const openPanel = useCallback((contact) => {
    setDetailContact(contact);
    setPanelOrders([]);
    setPanelOrdersLoading(true);
    requestAnimationFrame(() => requestAnimationFrame(() => setPanelOpen(true)));
    setPanelInfo(null);
    fetch(`https://talku.online/contacts/${contact.id}`, {headers:{'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`}})
      .then(r=>r.ok?r.json():null).then(d=>setPanelInfo(d)).catch(()=>{});
    api.getContactOrders(contact.id).then(data => {
      setPanelOrders(data.orders || []);
      setPanelOrdersLoading(false);
    }).catch(() => setPanelOrdersLoading(false));
  }, []);

  const closePanel = useCallback(() => {
    setPanelOpen(false);
    setTimeout(() => { setDetailContact(null); setPanelOrders([]); }, 300);
  }, []);

  const handleImportCSV = async (file) => {
    if (!file) return;
    setImporting(true);
    setImportResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch('https://talku.online/contacts/import/csv', {method:'POST', headers:{'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`}, body:formData});
      const data = await res.json().catch(()=>({}));
      if (!res.ok) { setImportResult({error: data.detail || `No se pudo importar (error ${res.status})`}); setImporting(false); return; }
      setImportResult(data);
      if (data.importados > 0) refresh();
    } catch (e) {
      setImportResult({error:'Error al importar el archivo'});
    }
    setImporting(false);
  };

  // Búsqueda y segmento los resuelve el backend (sobre todos los contactos)
  const filtered = contacts.filter(c => {
    return true;
  }).sort((a,b) => {
    let av = a[sortCol], bv = b[sortCol];
    if (typeof av === 'string') { av = (av||'').toLowerCase(); bv = (bv||'').toLowerCase(); }
    return sortDir === 'asc' ? (av > bv ? 1 : -1) : (av < bv ? 1 : -1);
  });

  const toggleSelect = (id) => setSelected(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev,id]);
  const toggleAll = () => setSelected(selected.length === filtered.length ? [] : filtered.map(c=>c.id));
  const handleSort = (col) => { if (sortCol === col) setSortDir(d=>d==='asc'?'desc':'asc'); else { setSortCol(col); setSortDir('asc'); } };
  const handleNav = (id, data) => { if (onNav) onNav(id, data); };

  const exportCSV = () => {
    const rows = ['Nombre,Teléfono,Email,Ciudad,Pedidos,Valor,Segmento',
      ...filtered.map(c=>`"${c.nombre}","${c.telefono||''}","${c.email||''}","${c.ciudad||''}",${c.pedidos},${c.valor||0},${c.segmento}`)
    ].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([rows],{type:'text/csv;charset=utf-8'}));
    a.download = 'contactos_talku.csv'; a.click();
  };

  const exportSelection = () => {
    const sel = contacts.filter(c=>selected.includes(c.id));
    const rows = ['Nombre,Teléfono,Email,Ciudad,Segmento',
      ...sel.map(c=>`"${c.nombre}","${c.telefono||''}","${c.email||''}","${c.ciudad||''}",${c.segmento}`)
    ].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([rows],{type:'text/csv;charset=utf-8'}));
    a.download = 'seleccion_contactos.csv'; a.click();
  };

  const refresh = () => { reload(); loadCounts(); };

  // Eliminar real: sin historial se borra; con pedidos/conversaciones se archiva (con advertencia)
  const authJ = () => ({'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`});
  const removeContacts = async (ids) => {
    if (!ids.length) return;
    let msg;
    if (ids.length === 1) {
      const c = contacts.find(x=>x.id===ids[0]);
      let u = { pedidos:0, conversaciones:0 };
      try { const r = await fetch(`https://talku.online/contacts/${ids[0]}/usage`, {headers:authJ()}); if (r.ok) u = await r.json(); } catch {}
      msg = (u.pedidos || u.conversaciones)
        ? `⚠️ ${c?.nombre||'Este contacto'} tiene ${u.pedidos} pedido${u.pedidos!==1?'s':''} y ${u.conversaciones} conversaci${u.conversaciones!==1?'ones':'ón'}.\n\nSe archivará: desaparece de Contactos, pero sus pedidos y conversaciones quedan intactos. Si vuelve a escribir o comprar, reaparece.\n\n¿Continuar?`
        : `¿Eliminar a ${c?.nombre||'este contacto'}? No tiene pedidos ni conversaciones, así que se borra definitivamente.`;
    } else {
      msg = `⚠️ Vas a eliminar ${ids.length} contactos.\n\nLos que no tienen historial se borran definitivamente. Los que tienen pedidos o conversaciones se archivan (su historial queda intacto y reaparecen si vuelven a escribir o comprar).\n\n¿Continuar?`;
    }
    if (!window.confirm(msg)) return;
    const done = [], fails = [];
    for (const id of ids) {
      try { const r = await fetch(`https://talku.online/contacts/${id}`, {method:'DELETE', headers:authJ()}); (r.ok ? done : fails).push(id); }
      catch { fails.push(id); }
    }
    setContacts(prev=>prev.filter(c=>!done.includes(c.id)));
    setTotalCount(n=>Math.max(0, n-done.length));
    setSelected([]);
    if (fails.length) alert(`No se pudieron eliminar ${fails.length} contacto(s). Intenta de nuevo.`);
  };

  const closeDropdowns = () => { setMenuId(null); setShowSegmento(false); setMoreMenu(false); };

  return (
    <>
      <style>{STYLES}</style>
      <div className="ct">
        {(menuId || showSegmento || moreMenu) && <div className="ct-backdrop" onClick={closeDropdowns}/>}

        {menuId && (
          <div className="ct-ctx" style={{top:menuPos.top,left:menuPos.left}}>
            <div className="ct-ctx-item" onClick={()=>{const c=contacts.find(x=>x.id===menuId);setMenuId(null);handleNav('Conversaciones', c?.telefono);}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              Abrir conversación
            </div>
            <div className="ct-ctx-item" onClick={()=>{const c=contacts.find(x=>x.id===menuId);setMenuId(null);if(c)openPanel(c);}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/></svg>
              Ver pedidos
            </div>
            <div className="ct-ctx-sep"/>
            <div className="ct-ctx-item ct-ctx-danger" onClick={()=>{const id=menuId;setMenuId(null);removeContacts([id]);}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/></svg>
              Eliminar
            </div>
          </div>
        )}

        <div className="ct-header">
          <div className="ct-title-row">
            <div>
              <h1 className="ct-title">Contactos</h1>
              <p className="ct-subtitle">{loading ? 'Cargando...' : `${contacts.length.toLocaleString()} cargados · ${totalCount.toLocaleString()} en total`}</p>
            </div>
            <div className="ct-actions">
              <button className="ct-btn ct-btn-import" onClick={()=>setShowImport(true)}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                Importar
              </button>
              <button className="ct-btn ct-btn-primary" onClick={()=>setShowCreate(true)}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                Crear
              </button>
              <div className="ct-more-wrap">
                <button className="ct-btn ct-btn-icon" onClick={()=>setMoreMenu(!moreMenu)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                </button>
                {moreMenu && (
                  <div className="ct-more-drop">
                    <div className="ct-more-item" onClick={()=>{exportCSV();setMoreMenu(false);}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                      Exportar CSV
                    </div>
                    <div className="ct-more-item" onClick={()=>{refresh();setMoreMenu(false);}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                      Actualizar
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="ct-controls">
          <div className="ct-tabs">
            {TABS.map(t => (
              <button key={t.id} className={`ct-tab${tab===t.id?' active':''}`} onClick={()=>{setTab(t.id);setSelected([]);}}>
                {t.label}
                <span className="ct-tab-count">{(t.id==='todos' ? totalCount : (segCounts?.[t.id] ?? 0)).toLocaleString('es-CO')}</span>
              </button>
            ))}
          </div>
          <div className="ct-controls-right">
            <div className="ct-search">
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#bbb" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round"/></svg>
              <input placeholder="Buscar por nombre, teléfono o correo…" value={search} onChange={e=>setSearch(e.target.value)}/>
              {search && <button className="ct-search-clear" onClick={()=>setSearch('')}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>}
            </div>
            <span className="ct-results">{filtered.length} resultado{filtered.length!==1?'s':''}</span>
          </div>
        </div>

        {selected.length > 0 && (
          <div className="ct-bulk">
            <span className="ct-bulk-info">{selected.length} seleccionado{selected.length>1?'s':''}</span>
            <button className="ct-bulk-btn" onClick={()=>setSelected([])}>Deseleccionar</button>
            <button className="ct-bulk-btn" onClick={exportSelection}>Exportar selección</button>
            <button className="ct-bulk-btn ct-bulk-danger" onClick={()=>removeContacts(selected)}>Eliminar</button>
          </div>
        )}

        <div className="ct-list-area" onScroll={handleScroll} ref={listRef}>
          <div className="ct-head">
            <div className="ct-head-cell">
              <input type="checkbox" className="ct-cb ct-cb-all" checked={selected.length===filtered.length&&filtered.length>0} onChange={toggleAll}/>
              <span onClick={()=>handleSort('nombre')} style={{cursor:'pointer',display:'flex',alignItems:'center',gap:4}}>
                Contacto {sortCol==='nombre'&&<SortArrow dir={sortDir}/>}
              </span>
            </div>
            <div className="ct-head-cell" style={{cursor:'default'}}>Último pedido</div>
            <div className="ct-head-cell ct-head-city" onClick={()=>handleSort('ciudad')}>Ciudad {sortCol==='ciudad'&&<SortArrow dir={sortDir}/>}</div>
            <div className="ct-head-cell" onClick={()=>handleSort('valor')}>Valor {sortCol==='valor'&&<SortArrow dir={sortDir}/>}</div>
            <div className="ct-head-cell" onClick={()=>handleSort('segmento')}>Segmento {sortCol==='segmento'&&<SortArrow dir={sortDir}/>}</div>
          </div>

          {loading && Array.from({length:8}).map((_,i)=>(
            <div key={i} className="ct-row" style={{animationDelay:`${i*40}ms`,cursor:'default'}}>
              <div className="ct-cell-contact" style={{gap:10}}>
                <div className="ct-skel ct-skel-circle"/>
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  <div className="ct-skel" style={{width:110+Math.round(i*15),height:12}}/>
                  <div className="ct-skel" style={{width:90,height:10}}/>
                </div>
              </div>
              <div className="ct-cell-product">
                <div className="ct-skel ct-skel-square"/>
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  <div className="ct-skel" style={{width:100+Math.round(i*10),height:12}}/>
                  <div className="ct-skel" style={{width:70,height:10}}/>
                </div>
              </div>
              <div className="ct-cell-city"><div className="ct-skel" style={{width:60,height:12}}/></div>
              <div className="ct-cell-value"><div className="ct-skel" style={{width:75,height:14}}/></div>
              <div><div className="ct-skel ct-skel-badge"/></div>
            </div>
          ))}

          {!loading && filtered.length===0 && (
            <div className="ct-empty">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.3" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              <p>No se encontraron contactos</p>
            </div>
          )}

          {!loading && filtered.map((c,idx)=>{
            const seg = SEGMENTO_CONFIG[c.segmento] || SEGMENTO_CONFIG.nuevo;
            const isSel = selected.includes(c.id);
            return (
              <div key={c.id} className={`ct-row${isSel?' selected':''}`} style={initialLoad.current?{animationDelay:`${Math.min(idx,12)*25}ms`}:undefined} onClick={()=>openPanel(c)}>
                <div className="ct-cell-contact">
                  <div className="ct-av-wrap">
                    <div className="ct-av" style={{background:AVATAR_COLORS[Math.abs(c.id||0)%AVATAR_COLORS.length]}}>{initials(c.nombre)}</div>
                    <div className="ct-cb-wrap" onClick={e=>e.stopPropagation()}>
                      <input type="checkbox" className="ct-cb" checked={isSel} onChange={()=>toggleSelect(c.id)}/>
                    </div>
                  </div>
                  <div className="ct-contact-info">
                    <div className="ct-name">{c.nombre}</div>
                    <div className="ct-phone">{c.telefono || '—'}</div>
                  </div>
                </div>

                <div className="ct-cell-product">
                  {c.pedidos > 0 ? (<>
                    <div className="ct-prod-thumb">
                      <div className="ct-prod-ph"><BagIcon/></div>
                      {c.ultimo_producto_img && <img src={c.ultimo_producto_img} alt="" onLoad={e=>e.target.classList.add('loaded')} onError={e=>{e.target.style.display='none'}}/>}
                      {(c.ultimo_pedido_items||0) > 1 && <span className="ct-prod-badge">+{c.ultimo_pedido_items-1}</span>}
                    </div>
                    <div className="ct-prod-info">
                      <div className="ct-prod-name">{c.ultimo_producto || `Pedido #${c.ultimo_pedido_num}`}</div>
                      <div className="ct-prod-meta">#{c.ultimo_pedido_num} · {fmtDate(c.ultima)}</div>
                    </div>
                  </>) : <span className="ct-no-order">Sin pedidos</span>}
                </div>

                <div className="ct-cell-city">{c.ciudad || '—'}</div>

                <div className="ct-cell-value">
                  <div className={`ct-val${(c.valor||0)===0?' ct-val-zero':''}`}>{(c.valor||0)>0?fmt(c.valor):'—'}</div>
                  <div className="ct-orders-count">{c.pedidos||0} pedido{(c.pedidos||0)!==1?'s':''}</div>
                </div>

                <div>
                  <span className="ct-seg" style={{'--seg':seg.color}}>{seg.label}</span>
                </div>

                <div className="ct-row-dots" onClick={e=>{e.stopPropagation();const r=e.currentTarget.getBoundingClientRect();setMenuPos({top:r.bottom/escZ()+4,left:r.right/escZ()-200});setMenuId(menuId===c.id?null:c.id);}}>
                  <button className="ct-dots-btn" type="button">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                  </button>
                </div>
              </div>
            );
          })}

          {loadingMore && <div className="ct-loading-more"><div className="ct-spinner"/>Cargando más contactos...</div>}

          {!loading && contacts.length > 0 && (
            <div className="ct-footer">
              <span>{contacts.length.toLocaleString()} cargados de {totalCount.toLocaleString()}</span>
              {!hasMore && <span className="ct-all-loaded">Todos cargados</span>}
            </div>
          )}
        </div>

        {detailContact && (() => {
          const dc = detailContact;
          const seg = SEGMENTO_CONFIG[dc.segmento] || SEGMENTO_CONFIG.nuevo;
          return (<>
          <div className={`ct-panel-overlay${panelOpen?' open':''}`} onClick={closePanel}/>
          <div className={`ct-panel${panelOpen?' open':''}`}>
            <div className="ctp-head">
              <div className="ctp-av" style={{background:AVATAR_COLORS[Math.abs(dc.id||0)%AVATAR_COLORS.length]}}>{initials(dc.nombre)}</div>
              <div style={{minWidth:0}}>
                <h2 className="ctp-name">{dc.nombre}</h2>
                <div className="ctp-meta"><span className="ct-seg" style={{'--seg':seg.color}}>{seg.label}</span><span className="ctp-sep">·</span>{dc.telefono || 'Sin teléfono'}</div>
              </div>
              <div className="ctp-actions">
                <button className="ct-btn ct-btn-primary" onClick={()=>{closePanel();handleNav('Conversaciones', dc.telefono);}}>Abrir conversación</button>
                <button className="ctp-x" onClick={closePanel} type="button" title="Cerrar">×</button>
              </div>
            </div>

            <div className="ctp-stats" style={{marginTop:18}}>
              <div className="ctp-stat"><small>Pedidos</small><b>{dc.pedidos||0}</b></div>
              <div className="ctp-stat"><small>Total comprado</small><b>{(dc.valor||0)>0 ? fmt(dc.valor) : '—'}</b></div>
              <div className="ctp-stat"><small>Último pedido</small><b>{dc.ultima ? fmtDate(dc.ultima) : '—'}</b></div>
            </div>

            <div className="ctp-grid">
              <div className="ctp-col">
                <div className="ctp-card">
                  <div className="ctp-h">Pedidos <span>{panelOrders.length > 0 ? `${panelOrders.length}` : ''}</span></div>
                  {panelOrdersLoading ? (
                    <div style={{display:'flex',flexDirection:'column',gap:14}}>
                      {[1,2,3].map(i=>(
                        <div key={i} style={{display:'flex',gap:12}}>
                          <div className="ct-skel" style={{width:48,height:48,borderRadius:6,flexShrink:0}}/>
                          <div style={{display:'flex',flexDirection:'column',gap:6,flex:1}}>
                            <div className="ct-skel" style={{width:'65%',height:12}}/>
                            <div className="ct-skel" style={{width:'40%',height:12}}/>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : panelOrders.length === 0 ? (
                    <p className="ct-panel-notes">Este contacto todavía no tiene pedidos.</p>
                  ) : panelOrders.map((order,idx) => {
                    const items = order.items || [];
                    const fi = items[0] || {};
                    const extra = items.length - 1;
                    const carrier = CARRIERS_MAP[(order.carrier||'').toLowerCase()];
                    const pm = PAYMENT_MAP[(order.payment_method||'').toLowerCase()];
                    const status = getOrderStatus(order);
                    return (
                      <div key={order.id} className="ct-panel-order" style={{animationDelay:`${Math.min(idx,8)*40}ms`}}>
                        <div className="ct-prod-thumb" style={{width:48,height:48}}>
                          <div className="ct-prod-ph"><BagIcon/></div>
                          {fi.image_url && <img src={fi.image_url} alt="" onLoad={e=>e.target.classList.add('loaded')} onError={e=>{e.target.style.display='none'}}/>}
                          {extra > 0 && <span className="ct-prod-badge">+{extra}</span>}
                        </div>
                        <div className="ct-panel-order-info">
                          <div style={{display:'flex',justifyContent:'space-between',gap:10}}>
                            <div className="ct-panel-order-title">{fi.title || `Pedido #${order.order_number}`}</div>
                            <div className="ct-panel-order-price">{fmt(parseFloat(order.total_price||0))}</div>
                          </div>
                          <div className="ct-panel-order-meta">
                            <span>#{order.order_number} · {fmtDate(order.created_at)}</span>
                            {carrier && (<><span>·</span><span style={{display:'inline-flex',alignItems:'center',gap:3}}><img src={carrier.img} alt=""/>{carrier.label}</span></>)}
                            {pm && pm.label !== 'Contra entrega' && (<><span>·</span><span style={{display:'inline-flex',alignItems:'center',gap:3}}>{pm.img && <img src={pm.img} alt=""/>}{pm.label}</span></>)}
                          </div>
                          <div className="ct-panel-order-status"><span className="ct-status-dot" style={{background:status.color}}/>{status.label}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="ctp-col">
                <div className="ctp-card">
                  <div className="ctp-h">Datos</div>
                  <div className="ctp-row"><span>Teléfono</span><b>{dc.telefono || '—'}</b></div>
                  <div className="ctp-row"><span>Correo</span><b>{panelInfo?.email || dc.email || '—'}</b></div>
                  {panelInfo?.created_at && <div className="ctp-row"><span>Cliente desde</span><b>{new Date(panelInfo.created_at).toLocaleDateString('es-CO',{day:'numeric',month:'short',year:'numeric'})}</b></div>}
                  {panelInfo?.tags && <div className="ctp-row"><span>Etiquetas</span><b>{panelInfo.tags}</b></div>}
                </div>
                {(() => {
                  const env = panelOrders.find(o => o.direccion || o.ciudad);
                  if (panelOrdersLoading) return null;
                  return (
                    <div className="ctp-card">
                      <div className="ctp-h">Dirección de envío {env && <span>pedido #{env.order_number}</span>}</div>
                      {env ? <>
                        <div className="ctp-row"><span>Dirección</span><b>{env.direccion || '—'}</b></div>
                        <div className="ctp-row"><span>Ciudad</span><b>{env.ciudad || '—'}</b></div>
                        <div className="ctp-row"><span>Departamento</span><b>{env.departamento || '—'}</b></div>
                      </> : <p className="ct-panel-notes">Sin dirección registrada. Se toma de sus pedidos.</p>}
                    </div>
                  );
                })()}
                {panelInfo?.notes && (
                  <div className="ctp-card">
                    <div className="ctp-h">Notas</div>
                    <p style={{margin:0,fontSize:13,color:'#374151',lineHeight:1.5,whiteSpace:'pre-wrap'}}>{panelInfo.notes}</p>
                  </div>
                )}
                <div className="ctp-card">
                  <div className="ctp-h">Acciones</div>
                  <div className="ctp-btns">
                    <button className="ct-btn ct-btn-danger" onClick={()=>{closePanel();removeContacts([dc.id]);}}>Eliminar contacto</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </>);
        })()}

        {showImport && (
          <div className="ct-overlay" onClick={()=>{setShowImport(false);setImportResult(null);}}>
            <div className="ct-modal" style={{width:520}} onClick={e=>e.stopPropagation()}>
              <div className="ct-modal-hdr">
                <div className="ct-modal-title">Importar contactos</div>
                <div className="ct-modal-close" onClick={()=>{setShowImport(false);setImportResult(null);}}>×</div>
              </div>
              {!importResult ? (<>
                <div className="ct-import-info">Compatible con <strong>Bird</strong>, <strong>Shopify</strong>, <strong>Excel</strong> y cualquier CSV. Las columnas se mapean automáticamente.</div>
                <div className="ct-modal-section">Formatos soportados</div>
                <div className="ct-import-formats">
                  {['Bird CSV','Shopify Customers','Excel exportado','WhatsApp contacts','Custom CSV'].map(f=><span key={f} className="ct-import-tag">{f}</span>)}
                </div>
                <input ref={fileInputRef} type="file" accept=".csv,.txt" style={{display:'none'}} onChange={e=>{if(e.target.files[0])handleImportCSV(e.target.files[0]);}}/>
                <div className={`ct-drop-zone${importing?' dragging':''}`}
                  onClick={()=>fileInputRef.current?.click()}
                  onDragOver={e=>{e.preventDefault();e.currentTarget.classList.add('dragging');}}
                  onDragLeave={e=>e.currentTarget.classList.remove('dragging')}
                  onDrop={e=>{e.preventDefault();e.currentTarget.classList.remove('dragging');const f=e.dataTransfer.files[0];if(f)handleImportCSV(f);}}
                >
                  {importing ? (
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:10}}>
                      <div className="ct-spinner" style={{width:24,height:24,borderWidth:3}}/>
                      <div style={{fontSize:13,color:'#888'}}>Procesando archivo...</div>
                    </div>
                  ) : (<>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" style={{marginBottom:8}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    <div style={{fontSize:14,fontWeight:500,color:'#111',marginBottom:3}}>Arrastra tu CSV aquí</div>
                    <div style={{fontSize:12,color:'#aaa'}}>o haz clic para seleccionar</div>
                  </>)}
                </div>
                <div className="ct-import-help">
                  <strong>Bird:</strong> Contactos → Exportar → CSV<br/>
                  <strong>Shopify:</strong> Clientes → Exportar → Todos los clientes<br/>
                  <strong>Mínimo requerido:</strong> nombre O teléfono O email
                </div>
              </>) : (
                <div>
                  {importResult.error ? (
                    <div className="ct-modal-err" style={{marginTop:0}}>{importResult.error}</div>
                  ) : (<>
                    <div className="ct-import-result">
                      <div className="ct-import-result-num">{importResult.importados?.toLocaleString()}</div>
                      <div className="ct-import-result-label">contactos importados</div>
                      {(importResult.duplicados > 0 || importResult.sin_telefono > 0 || importResult.invalidos > 0 || importResult.errores > 0) && <div style={{fontSize:12,color:'#6B7280',marginTop:6,lineHeight:1.6}}>
                        {importResult.duplicados > 0 && <div>{importResult.duplicados} ya existían (no se duplicaron)</div>}
                        {importResult.sin_telefono > 0 && <div>{importResult.sin_telefono} filas sin teléfono</div>}
                        {importResult.invalidos > 0 && <div>{importResult.invalidos} con teléfono no válido</div>}
                        {importResult.errores > 0 && <div>{importResult.errores} filas con errores</div>}
                      </div>}
                    </div>
                    <div className="ct-modal-section">Vista previa</div>
                    {importResult.contacts?.map((c,i)=>(
                      <div key={i} className="ct-import-preview">
                        <div className="ct-import-preview-av" style={{background:AVATAR_COLORS[i%AVATAR_COLORS.length]}}>{initials(c.nombre)}</div>
                        <div>
                          <div style={{fontSize:12,fontWeight:400,color:'#111'}}>{c.nombre}</div>
                          <div style={{fontSize:11,color:'#aaa'}}>{c.telefono||c.email||'—'}</div>
                        </div>
                      </div>
                    ))}
                  </>)}
                  <button className="ct-modal-submit" onClick={()=>{setShowImport(false);setImportResult(null);}}>Cerrar</button>
                </div>
              )}
            </div>
          </div>
        )}

        {showCreate && (
          <div className="ct-overlay" onClick={()=>!creating && setShowCreate(false)}>
            <div className="ct-modal" style={{width:460}} onClick={e=>e.stopPropagation()}>
              <div className="ct-modal-hdr">
                <div className="ct-modal-title">Nuevo contacto</div>
                <div className="ct-modal-close" onClick={()=>setShowCreate(false)}>×</div>
              </div>
              <div className="ct-modal-grid">
                {[{k:'nombre',l:'Nombre completo',ph:'María Rodríguez'},{k:'telefono',l:'Teléfono WhatsApp',ph:'300 000 0000'},{k:'email',l:'Correo (opcional)',ph:'correo@ejemplo.com'}].map(f=>(
                  <div key={f.k} className="ct-modal-field"><label>{f.l}</label><input value={newContact[f.k]||''} onChange={e=>setNewContact({...newContact,[f.k]:e.target.value})} placeholder={f.ph}/></div>
                ))}
              </div>
              <div className="ct-modal-field" style={{marginTop:12}}><label>Notas (opcional)</label><textarea rows={3} value={newContact.notas||''} onChange={e=>setNewContact({...newContact,notas:e.target.value})} placeholder="Ej: cliente referido por…" style={{width:'100%',resize:'vertical',fontFamily:'inherit'}}/></div>
              {createErr && <div className="ct-modal-err">{createErr}</div>}
              <button className="ct-modal-submit" disabled={creating} onClick={async()=>{
                setCreateErr('');
                if(!newContact.nombre?.trim()) return setCreateErr('Escribe el nombre.');
                if((newContact.telefono||'').replace(/\D/g,'').replace(/^57(?=\d{10}$)/,'').length!==10) return setCreateErr('El teléfono debe tener 10 dígitos.');
                setCreating(true);
                try {
                  const r = await fetch('https://talku.online/contacts/', {method:'POST', headers:{'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`,'Content-Type':'application/json'}, body: JSON.stringify({nombre:newContact.nombre, telefono:newContact.telefono, email:newContact.email||null, notas:newContact.notas||null})});
                  const d = await r.json().catch(()=>({}));
                  if (!r.ok) { setCreateErr(d.detail || `No se pudo crear (error ${r.status})`); setCreating(false); return; }
                  setContacts(prev=>[d,...prev]); setTotalCount(n=>n+1);
                  setShowCreate(false); setNewContact({nombre:'',telefono:'',email:'',notas:''});
                } catch { setCreateErr('Error de conexión.'); }
                setCreating(false);
              }}>{creating ? 'Creando…' : 'Crear contacto'}</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
